const timeline = () => {
  const test = document.querySelector('.js-timeline')

  if (!test) return

  const timeline = document.querySelector('.timeline'),
    timelineWrapper = document.querySelector('.timeline-wrap'),
    timelineHeight = timeline.clientHeight,
    vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    ),
    timelinePoints = document.querySelectorAll('[data-timeline-point]')

  let timelineCompletion = false

  const initTimelineItem = () => {
    for (var i = 0; i < timelinePoints.length; i++) {
      const distFromTop = timelinePoints[i].getBoundingClientRect().top
      if (
        timelinePoints[i]
          .closest('.timeline-item')
          .classList.contains('js-inactive') &&
        distFromTop <= vh * 0.6
      ) {
        const listItem = timelinePoints[i].closest('.timeline-item')
        listItem.classList.remove('js-inactive')
        listItem.ariaHidden = false
      }
    }
  }

  const setTimelineTransform = (timeline) => {
    const distFromTop = timelineWrapper.getBoundingClientRect().top

    const pctTimelineInView =
      Math.min(Math.max(vh - (distFromTop + vh * 0.4), 0), timelineHeight) /
      timelineHeight

    timeline.style.height = `${pctTimelineInView * 100}%`

    if (pctTimelineInView === 1) {
      timelineCompletion = true

      timeline.parentElement.classList.remove('js-unfilled')
    }
  }

  /* On page load */
  initTimelineItem()
  setTimelineTransform(timeline)

  window.addEventListener('scroll', () => {
    if (timelineCompletion === true) return

    setTimelineTransform(timeline)
    initTimelineItem()
  })
}

//https://codepen.io/spencerrowland/pen/oNzeMqe

export default timeline
